import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import LocalizedText, { localize } from 'commons/LocalizedText/LocalizedText';
import { CustomTooltip } from 'commons/Tooltip/CustomTooltip';
import DownloadIcon from "commons/Icon/DownloadIcon";

const FILE_NAME_MAX_LENGTH = 25;

const useStyles = makeStyles(() => ({
  generalContainer: {
    minHeight: '70px'
  },
  link: {
    cursor: 'pointer'
  }
}));

export const FileWithLabel = ({file, label}) => {
  const classes = useStyles();
  return (
    <Grid item>
      <Grid alignItems='center' className={classes.generalContainer} container spacing={2} wrap="nowrap">
        <Grid item xs={6}>
          <LocalizedText  align='right' isTextLabel >
            {label}
          </LocalizedText>
        </Grid>
        {file && file.name ?
          <Grid className={classes.link} item onClick={() => { window.location.href = file.path; }} xs={6}>
            <CustomTooltip title={`${localize('download')} ${file.name ?? ''}`}>
              <Grid alignItems='center' container spacing={1} wrap='nowrap'>
                <Grid item>
                  <DownloadIcon size="medium"/>
                </Grid>
                <Grid item>
                  {file.name.substring(0, FILE_NAME_MAX_LENGTH) + '...'}
                </Grid>
              </Grid>
            </CustomTooltip>
          </Grid>
          :
          <Grid item xs={6}>
            <Typography>
              -
            </Typography>
          </Grid>
        }
      </Grid>
    </Grid>
  );
};